import { PropertyEmailLookupModelDto } from './../../models/lookup/property.lookup-email.model';
import { ApiResponse } from '../../models/app-configuration';
import { ActionTree } from 'vuex';

import { ILookupState } from './lookup-states.store';
import { commonUri } from '../../common';
import { LOOKUP_TYPE } from './lookup-properties.store';
import lookupTypesStore from './lookup-types.store';
import { IGenericObject } from '../../models/common';
import { PersonServices } from '../../services/index';
import { DataHelper } from '../../utils/data-helper';
import { LOOKUP_ROOM_COVERING, LOOKUP_ROOM_DESCRIPTIONS, LOOKUP_ROOM_STATES, LOOKUP_ROOM_FLOORS, LOOKUP_ROOM_KEYWORDS, LOOKUP_ADMINISTRATION_OILTANKPLACEMENT, LOOKUP_ADMINISTRATION_GROUNDCERTIFICATE, LOOKUP_ADMINISTRATION_EPCBRUSSELS, LOOKUP_ADMINISTRATION_OILTANKFURTHEREXPLOITATION, LOOKUP_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION, LOOKUP_ADMINISTRATION_ELECTRICITYIMMOWEB, LOOKUP_ADMINISTRATION_GASOLINEIMMOWEB, LOOKUP_ADMINISTRATION_PERMITOPTIONS, LOOKUP_ADMINISTRATION_AREAAPPLICATION, LOOKUP_ADMINISTRATION_HERITAGETYPE, LOOKUP_ADMINISTRATION_YESNO, LOOKUP_ADMINISTRATION_FLOODRISK, LOOKUP_MAN_WOMAN, LOOKUP_VIAGER_TYPE, LOOKUP_CHARGE_ELEMENTS, LOOKUP_PUBLIC_UTILITIES, LOOKUP_ADMINISTRATION_HAS_SUMMON, LOOKUP_ADMINISTRATION_EPCIMMOWEB, LOOKUP_ADMINISTRATION_EPCFLANDERS, LOOKUP_ADMINISTRATION_CO2_EMISSION, LOOKUP_ADMINISTRATION_INSULATION, LOOKUP_ADMINISTRATION_EPCLUXEMBOURG, LOOKUP_ASBESTOS_TYPE, LOOKUP_ADMINISTRATION_FLOODTYPE, LOOKUP_ADMINISTRATION_EPCTYPE, LOOKUP_ADMINISTRATION_EPCNR, LOOKUP_ADMINISTRATION_EPCkNR } from '../../common/lookup-types.constant';

const actions = <ActionTree<ILookupState, any>>{
    [lookupTypesStore.Get.LOOKUP_COLOR]: ({ getters, commit }, type: string) => {
        const typeList = type.split(',');
        const unAvailableTypes = typeList.filter(item => {
            return !getters.storedlookupObject[item] || getters.storedlookupObject[item].length === 0
        })
        if (unAvailableTypes.length === 0) {
            const result = typeList.length > 1 ? true : getters.storedlookupObject[type];
            return Promise.resolve(result);
        }

        return getters.service.select(undefined, commonUri.getLookupColor + '/' + unAvailableTypes.join(','))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    let data = response.data;
                    const listOfLookupKeys = Object.keys(data);
                    listOfLookupKeys.forEach(key => {
                        let lookupValue = data[key];
                        if (LOOKUP_TYPE.Site === key) {
                            lookupValue = lookupValue.filter(item => item.Id !== -1)
                        }
                        commit(lookupTypesStore.Set.STORED_LOOKUP_COLOR, { key: key, data: lookupValue });
                    })
                }
                return typeList.length > 1 ? Promise.resolve(true) : Promise.resolve(response.data[type]);
            })
    },
  [lookupTypesStore.Get.LOOKUP_DATA]: ({ getters, commit }, type: string) => {
    const typeList = type.split(',');
    const unAvailableTypes = typeList.filter(item => {
      return !getters.storedlookupObject[item] || getters.storedlookupObject[item].length === 0
    })
    if (unAvailableTypes.length === 0) {
      const result = typeList.length > 1 ? true : getters.storedlookupObject[type];
      return Promise.resolve(result);
    }

    return getters.service.select(undefined, commonUri.getLookupData + '/' + unAvailableTypes.join(','))
    .then((response: ApiResponse) => {
      if (response.isSuccess) {
        let data = response.data;
        const listOfLookupKeys = Object.keys(data);
        listOfLookupKeys.forEach(key => {
          let lookupValue = data[key];
          if (LOOKUP_TYPE.Site === key) {
            lookupValue = lookupValue.filter(item => item.Id !== -1)
          }
          commit(lookupTypesStore.Set.STORED_LOOKUP_OBJECT, {key: key, data: lookupValue});
        })
      }
      return typeList.length > 1 ? Promise.resolve(true) : Promise.resolve(response.data[type]);
    })
  },
  [lookupTypesStore.Get.LOOKUP_DATA_ALL_LANGUAGE]: ({ getters, commit }, type: string) => {
    return getters.service.select(undefined, commonUri.getLookupData + '/' + type + '?lang=all')
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          let data = response.data;
            if (data) {
              return Promise.resolve(data);
            }
            return Promise.resolve({});
        }
        return Promise.resolve({});
      })
  },
  [lookupTypesStore.Get.LIST_OF_RELATION_REVERSE_TYPES]: ({ getters, commit }, params: any) => {
    if(getters.storedlookupObject[LOOKUP_TYPE.RelationType] &&  getters.storedlookupObject[LOOKUP_TYPE.RelationType].length > 0)
      return Promise.resolve(getters.storedlookupObject[LOOKUP_TYPE.RelationType]);
    (getters.service as PersonServices).select(params, commonUri.getLookupData + '/' + LOOKUP_TYPE.RelationType)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          commit(lookupTypesStore.Set.LIST_OF_RELATION_REVERSE_TYPES, response.data[LOOKUP_TYPE.RelationType]);
        }
      })
  },
  [lookupTypesStore.Get.LIST_TYPES_OF_PROPERTY]: ({ getters, commit }) => {
    if (getters.listTypesOfProperty && getters.listTypesOfProperty.length > 0)
      return Promise.resolve(getters.listTypesOfProperty);
    else return getters.service.getListTypesOfProperty()
      .then((listTypesOfProperty: IGenericObject[]) => {
        commit(lookupTypesStore.Set.LIST_TYPES_OF_PROPERTY, listTypesOfProperty)
        return Promise.resolve(listTypesOfProperty);
      })
      .catch(ex => {
        console.log(ex);
        commit(lookupTypesStore.Set.LIST_TYPES_OF_PROPERTY, []);
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_OF_PURPOSES]: ({ getters, commit }) => {
    if (getters.listOfPurposes && getters.listOfPurposes.length > 0)
      return Promise.resolve(getters.listOfPurposes);
    else return getters.service.getListOfPurposes()
      .then((listOfPurposes: IGenericObject[]) => {
        commit(lookupTypesStore.Set.LIST_OF_PURPOSES, listOfPurposes)
        return Promise.resolve(listOfPurposes);
      })
      .catch(ex => {
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_OF_GOALS]: ({ getters, commit }) => {
    if (getters.listOfGoals && getters.listOfGoals.length > 0)
      return Promise.resolve(getters.listOfGoals);
    else return getters.service.getListOfGoals()
      .then((listOfGoals: IGenericObject[]) => {
        commit(lookupTypesStore.Set.LIST_OF_GOALS, listOfGoals);
        return Promise.resolve(listOfGoals);
      })
      .catch(ex => {
        console.log(ex);
        commit(lookupTypesStore.Set.LIST_OF_GOALS, []);
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_OF_STATUS]: ({ getters, commit }) => {
    if (getters.listOfStatus && getters.listOfStatus.length > 0) {
      return Promise.resolve(getters.listOfStatus);
    }
    else return getters.service.getListOfStatuses()
      .then((listOfStatus: IGenericObject[]) => {
        commit(lookupTypesStore.Set.LIST_OF_STATUS, listOfStatus)
        return Promise.resolve(listOfStatus);
      })
      .catch(ex => {
        console.log(ex);
        commit(lookupTypesStore.Set.LIST_OF_STATUS, []);
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_OF_SINCE_DATE]: ({ getters, commit }) => {
    if (getters.listOfSinceDate && getters.listOfSinceDate.length > 0) {
      return Promise.resolve(getters.listOfSinceDate);
    }
    else return getters.service.getListOfSinceDate()
      .then((listOfSinceDate: IGenericObject[]) => {
        commit(lookupTypesStore.Set.LIST_OF_SINCE_DATE, listOfSinceDate)
        return Promise.resolve(listOfSinceDate);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_TYPES_OF_DOCUMENT]: ({ getters, commit }) => {
    if (getters.listOfDocumentTypes && getters.listOfDocumentTypes.length > 0 ) {
      return Promise.resolve(getters.listOfDocumentTypes);
    }
    else getters.service.select(undefined, commonUri.getLookupData + '/' + LOOKUP_TYPE.DocumentTypes)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          var data = response.data[LOOKUP_TYPE.DocumentTypes];
          commit(lookupTypesStore.Set.LIST_TYPES_OF_DOCUMENT, data)
          return Promise.resolve(data);
        }
      })
      .catch(ex => {
        commit(lookupTypesStore.Set.LIST_TYPES_OF_DOCUMENT, []);
        return Promise.reject(ex);
      })
  },

  [lookupTypesStore.Get.LIST_PUBLISH_TYPES_OF_DOCUMENT]: ({ getters, commit }) => {
    if (getters.listOfDocumentPublish && getters.listOfDocumentPublish.length > 0) {
      return Promise.resolve(getters.listOfDocumentPublish);
    }
    else getters.service.select(undefined, commonUri.getLookupData + '/' + LOOKUP_TYPE.DocumentPublish)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          var data = response.data[LOOKUP_TYPE.DocumentPublish];
          commit(lookupTypesStore.Set.LIST_PUBLISH_TYPES_OF_DOCUMENT, data)
          return Promise.resolve(data);
        }
      })
      .catch(ex => {
        console.log(ex);
        commit(lookupTypesStore.Set.LIST_PUBLISH_TYPES_OF_DOCUMENT, []);
        return Promise.reject(ex);
      })
  },
  [lookupTypesStore.Get.LIST_PUBLISH_TYPES_OF_DOCUMENT]: ({ getters, commit }) => {
    if (getters.listOfDocumentPublish && getters.listOfDocumentPublish.length > 0) {
      return Promise.resolve(getters.listOfDocumentPublish);
    }
    else getters.service.select(undefined, commonUri.getLookupData + '/' + LOOKUP_TYPE.DocumentPublish)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          var data = response.data[LOOKUP_TYPE.DocumentPublish];
          commit(lookupTypesStore.Set.LIST_PUBLISH_TYPES_OF_DOCUMENT, data)
          return Promise.resolve(data);
        }
      })
      .catch(ex => {
        console.log(ex);
        commit(lookupTypesStore.Set.LIST_PUBLISH_TYPES_OF_DOCUMENT, []);
        return Promise.reject(ex);
      })
  },
  [lookupTypesStore.Get.LIST_OF_PICTUREGROUP]: ({ getters, commit }) => {
    if (getters.listOfPictureGroups && getters.listOfPictureGroups.length > 0) {
      return Promise.resolve(getters.listOfPictureGroups);
    }
    else getters.service.select(undefined, commonUri.getLookupData + '/' + LOOKUP_TYPE.PictureGroups)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          var data = response.data[LOOKUP_TYPE.PictureGroups];
          commit(lookupTypesStore.Set.LIST_OF_PICTUREGROUP, data)
          return Promise.resolve(data);
        }
      })
      .catch(ex => {
        console.log(ex);
        commit(lookupTypesStore.Set.LIST_PUBLISH_TYPES_OF_DOCUMENT, []);
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_OF_ROOM_LOOKUPS]: ({ getters, commit }) => {
    const lookupTypes: string[] = [];

    if (getters.listOfRoomStates === null) {
      lookupTypes.push(LOOKUP_ROOM_STATES);
    }

    if (getters.listOfRoomDescriptions === null) {
      lookupTypes.push(LOOKUP_ROOM_DESCRIPTIONS);
    }

    if (getters.listOfRoomCovering === null) {
      lookupTypes.push(LOOKUP_ROOM_COVERING);
    }

    if (getters.listOfRoomFloors === null) {
      lookupTypes.push(LOOKUP_ROOM_FLOORS);
    }

    if (getters.listOfRoomKeywords === null) {
      lookupTypes.push(LOOKUP_ROOM_KEYWORDS);
    }

    if (lookupTypes.length === 0)
      return Promise.resolve({
        listOfRoomFloors: getters.listOfRoomFloors,
        listOfRoomDescriptions: getters.listOfRoomDescriptions,
        listOfRoomStates: getters.listOfRoomStates,
        listOfRoomCovering: getters.listOfRoomCovering,
        listOfRoomKeywords: getters.listOfRoomKeywords
    });

    return getters.service.select(undefined, commonUri.getLookupData + '/' + lookupTypes.join(','))
      .then((response: ApiResponse) => {
        if (response.isSuccess) {

          if(response.data['FloorCovering'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ROOM_COVERING, response.data['FloorCovering']);
          } 
          
          if(response.data['ConditionRooms'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ROOM_STATES, response.data['ConditionRooms']);
          }  

          if(response.data['RoomTypes'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ROOM_DESCRIPTIONS, response.data['RoomTypes']);
          }  

          if(response.data['FloorValues'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ROOM_FLOORS, response.data['FloorValues']);
          }  

          if(response.data['Keywords'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ROOM_KEYWORDS, response.data['Keywords']);
          }  
          
          return Promise.resolve(response.data);
        }
        else return Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      })
  }


  , [lookupTypesStore.Get.LIST_OF_ADMINISTRATION_LOOKUPS]: ({ getters, commit }) => {
    const lookupTypes: string[] = [];
    if (!getters.listOfCO2Emission) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_CO2_EMISSION);
    }
    if (!getters.listOfInsulation) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_INSULATION);
    }
    if (!getters.listOfEPCLuxembourg) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCLUXEMBOURG);
    }
    if (!getters.listOfEPCImmoWeb) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCIMMOWEB);
    }
    if (!getters.listOfEPCType) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCTYPE);
    }
    if (!getters.listOfEPCNR) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCNR);
    }
    if (!getters.listOfEPCkNR) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCkNR);
    }
    if (!getters.listOfEPCFlanders) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCFLANDERS);
    }
    if (!getters.listOfEPCBrussels) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_EPCBRUSSELS);
    }
    if (!getters.listOfGroundCertificate) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_GROUNDCERTIFICATE);
    }
    if (!getters.listOfOilTankPlacement) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_OILTANKPLACEMENT);
    }
    if (!getters.listOfOilTankFurtherExploitation) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_OILTANKFURTHEREXPLOITATION);
    }
    if (!getters.listOfOilTankCertificateOfInspection) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION);
    }
    if (!getters.listOfElectricityImmoWeb) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_ELECTRICITYIMMOWEB);
    }
    if (!getters.listOfGasolineImmoWeb) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_GASOLINEIMMOWEB);
    }

    if (!getters.listOfPermitOptions) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_PERMITOPTIONS);
    }
    if (!getters.listOfAreaApplication) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_AREAAPPLICATION);
    }
    if (!getters.listOfHeritageType) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_HERITAGETYPE);
    }
    if (!getters.listOfFloodRisk) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_FLOODRISK);
    }
    if (!getters.listOfFloodZoneType) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_FLOODTYPE);
    }
    if (!getters.listOfYesNo) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_YESNO);
    }
    if (!getters.listOfHasSummon) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_HAS_SUMMON);
    }
    if(!getters.listOfAsbestosType) {
      lookupTypes.push(LOOKUP_ASBESTOS_TYPE);
    }

    if (lookupTypes.length === 0)
      return Promise.resolve({
        listOfCO2Emission: getters.listOfCO2Emission,
        listOfInsulation: getters.listOfInsulation,
        listOfEPCLuxembourg: getters.listOfEPCLuxembourg,
        listOfEPCImmoWeb: getters.listOfEPCImmoWeb,
        listOfEPCFlanders: getters.listOfEPCFlanders,
        listOfEPCBrussels: getters.listOfEPCBrussels,
        listOfEPCType: getters.listOfEPCType,
        listOfEPCNR: getters.listOfEPCNR,
        listOfEPCkNR: getters.listOfEPCkNR,
        listOfGroundCertificate: getters.listOfGroundCertificate,
        listOfOilTankPlacement: getters.listOfOilTankPlacement,
        listOfOilTankFurtherExploitation: getters.listOfOilTankFurtherExploitation,
        listOfOilTankCertificateOfInspection: getters.listOfOilTankCertificateOfInspection,
        listOfElectricityImmoWeb: getters.listOfElectricityImmoWeb,
        listOfGasolineImmoWeb: getters.listOfGasolineImmoWeb,
        listOfPermitOptions: getters.listOfPermitOptions,
        listOfAreaApplication: getters.listOfAreaApplication,
        listOfHeritageType: getters.listOfHeritageType,
        listOfFloodRisk: getters.listOfFloodRisk,
        listOfFloodType: getters.listOfFloodType,
        listOfYesNo: getters.listOfYesNo,
        listOfHasSummon: getters.listOfHasSummon,
        listOfAsbestosType: getters.listOfAsbestosType
      })
    return getters.service.executeSelectingPost({ Types: lookupTypes }, commonUri.getLookupData)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          if (response.data['CO2Luxembourg']) {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_CO2_EMISSION, response.data['CO2Luxembourg']);
          }
          if (response.data['InsulationLuxembourg']) {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_INSULATION, response.data['InsulationLuxembourg']);
          }
          if (response.data['EPCLuxembourg']) {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCLUXEMBOURG, response.data['EPCLuxembourg']);
          }

          if(response.data['EPCBrussels'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCBRUSSELS, response.data['EPCBrussels']);
          } 

          if(response.data['EPCFlanders'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCFLANDERS, response.data['EPCFlanders']);
          } 

          if(response.data['EPCImmoWeb'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCIMMOWEB, response.data['EPCImmoWeb']);
          }

          if(response.data['EPCType'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCTYPE, response.data['EPCType']);
          }

          if(response.data['EPCNR'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCNR, response.data['EPCNR']);
          }

          if(response.data['EPCkNR'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_EPCkNR, response.data['EPCkNR']);
          }

          if(response.data['GroundCertificate'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_GROUNDCERTIFICATE, response.data['GroundCertificate']);
          } 

          if(response.data['OilTankPlacement'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_OILTANKPLACEMENT, response.data['OilTankPlacement']);
          }

          if(response.data['OilTankFurtherExploitation'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_OILTANKFURTHEREXPLOITATION, response.data['OilTankFurtherExploitation']);
          }

          if(response.data['OilTankCertificateOfInspection'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION, response.data['OilTankCertificateOfInspection']);
          }

          if(response.data['ElectricityImmoWeb'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_ELECTRICITYIMMOWEB, response.data['ElectricityImmoWeb']);
          }
          
          if(response.data['GasolineImmoWeb'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_GASOLINEIMMOWEB, response.data['GasolineImmoWeb']);
          }
          
          if(response.data['PermitOptions'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_PERMITOPTIONS, response.data['PermitOptions']);
          }

          if(response.data['HasSummon'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_HAS_SUMMON, response.data['HasSummon']);
          }

          if(response.data['AreaApplication'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_AREAAPPLICATION, response.data['AreaApplication']);
          }

          if(response.data['HeritageType'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_HERITAGETYPE, response.data['HeritageType']);
          }

          if(response.data['FloodRisk'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_FLOODRISK, response.data['FloodRisk']);
          }

          if(response.data['FloodZone2023'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_FLOODZONE, response.data['FloodZone2023']);
          }
               
          if(response.data['YesNo'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_YESNO, response.data['YesNo']);
          }

          if(response.data['AsbestosType'])
          {
            commit(lookupTypesStore.Set.LIST_OF_ASBESTOS_PLATFORM, response.data['AsbestosType']);
          }

          return Promise.resolve(response.data);
        }
        else return Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      })
  }
  , [lookupTypesStore.Get.LIST_OF_ORIENTATIONS]: ({ getters, commit }) => {
    if (getters.listOfOrientations && getters.listOfOrientations.length > 0) {
      return Promise.resolve(getters.listOfOrientations)
    } else {
      return getters.service.getListOfOrientations()
        .then((listOfOrientations: IGenericObject[]) => {
          commit(lookupTypesStore.Set.LIST_OF_ORIENTATIONS, listOfOrientations)
          return Promise.resolve(listOfOrientations);
        })
        .catch(ex => {
          console.log(ex);
          return Promise.reject(ex);
        })
    }
  }

  /** LIST OF EMAIL BY PROPERTY IDS */
  , [lookupTypesStore.Set.LIST_OF_EMAIL_BY_PROPERTYIDS]: ({ getters, commit}, propetyIds: number[] ) => {
    if (getters[lookupTypesStore.Get.LIST_OF_EMAIL_BY_PROPERTYIDS] && getters[lookupTypesStore.Get.LIST_OF_EMAIL_BY_PROPERTYIDS].length > 0) {
      return Promise.resolve(getters[lookupTypesStore.Get.LIST_OF_EMAIL_BY_PROPERTYIDS])
    } else {
      return getters.service.getListOfEmailsByPropertyIds(propetyIds)
        .then((source: PropertyEmailLookupModelDto[]) => {
          commit(lookupTypesStore.Set.LIST_OF_EMAIL_BY_PROPERTYIDS, source)
          return Promise.resolve(source);
        })
        .catch(ex => {
          console.log(ex);
          return Promise.reject(ex);
        })
    }
  }
  //#Property/Finance Tab
  , [lookupTypesStore.Get.LIST_OF_FINANCE]: ({ getters, commit}) => {
    const lookupTypes: string[] = [];
    //List of Yes No
    if (getters.listOfYesNo === null) {
      lookupTypes.push(LOOKUP_ADMINISTRATION_YESNO);
    }
    //List of Man Woman
    if (getters.listOfManWoman === null) {
      lookupTypes.push(LOOKUP_MAN_WOMAN);
    }
    //List of Viager Type
    if (getters.listOfViagerType === null) {
      lookupTypes.push(LOOKUP_VIAGER_TYPE);
    }

    if (getters.listOfChargeElements === null) {
      lookupTypes.push(LOOKUP_CHARGE_ELEMENTS);
    }

    if (getters.listOfPublicUtilities === null) {
      lookupTypes.push(LOOKUP_PUBLIC_UTILITIES);
    }

    if (lookupTypes.length === 0)
    {
      return Promise.resolve({
        listOfYesNo: getters.listOfYesNo,
        listOfManWoman: getters.listOfManWoman,
        listOfViagerType: getters.listOfViagerType,
        listOfChargeElements: getters.listOfChargeElements,
        listOfPublicUtilities: getters.listOfPublicUtilities,
      })
    }   

    return getters.service.select(undefined, commonUri.getLookupData + '/' + lookupTypes.join(','))
    .then((response: ApiResponse) => {
      if (response.isSuccess) {
        if(response.data['YesNo'])
        {
          commit(lookupTypesStore.Set.LIST_OF_ADMINISTRATION_YESNO, response.data['YesNo'])
        }

        if(response.data['ManWoman'])
        {
          commit(lookupTypesStore.Set.LIST_OF_MANWOMAN, response.data['ManWoman'])
        }

        if(response.data['ViagerType'])
        {
          commit(lookupTypesStore.Set.LIST_OF_VIAGERTYPE, response.data['ViagerType'])
        }

        if(response.data['ChargeElements'])
        {
          commit(lookupTypesStore.Set.LIST_OF_CHARGE_ELEMENTS, response.data['ChargeElements'])
        }

        if(response.data['PublicUtilities'])
        {
          commit(lookupTypesStore.Set.LIST_OF_PUBLIC_UTILITIES, response.data['PublicUtilities'])
        }
        return Promise.resolve(response.data);
      }
      else return Promise.reject(response.message);
    })
    .catch(ex => {
      return Promise.reject(ex);
    })
  }
  //lookup register types
  , [lookupTypesStore.Get.LIST_OF_REGISTERED_TYPE]: ({ getters, commit}, postCode:number,displayField:string ='Description') => {
    
    const region = DataHelper.convertPostCodeToRegion(postCode);

    if (getters["listOfRegisteredType"+region] === null || getters["listOfRegisteredType"+region].length == 0) {
      return getters.service.select(undefined, commonUri.getLookupData + '/RegistrationType?regionType='+region+'&displayField='+displayField,false)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          commit(lookupTypesStore.Set['LIST_OF_REGISTERED_TYPE_'+region.toUpperCase()], response.data['RegistrationType'])
          return Promise.resolve(response.data);
        }
        else return Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      })
    }
    else{
      return Promise.resolve({RegistrationType:getters["listOfRegisteredType"+region]});
    }
  }
   
  , [lookupTypesStore.Get.LIST_OF_APPOINTMENT_STATUS]: ({ getters, commit}) => {
    if (getters.getListOfAppointmentStatus && getters.getListOfAppointmentStatus.length > 0) return getters.getListOfAppointmentStatus.length;
    return getters.service.getListOfAppointmentStatus()
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          commit(lookupTypesStore.Set.LIST_OF_APPOINTMENT_STATUS, response.data);
          return Promise.resolve(response.data);
        }
        return Promise.reject(response.message);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }
  , [lookupTypesStore.Get.LIST_OF_APPOINTMENT_TYPE]: ({getters, commit}) => {
    if (getters.getListOfAppointmentType.length && getters.getListOfAppointmentType.length > 0) {
      return Promise.resolve(getters.getListOfAppointmentType);
    };
    return getters.service.getListOfAppointmentTypes()
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          commit(lookupTypesStore.Set.LIST_OF_APPOINTMENT_TYPE, response.data);
          return Promise.resolve(response.data);
        }
        return Promise.reject(response.message);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }
  , [lookupTypesStore.Get.LIST_OF_DURATION_TASKS]: ({ getters, commit }) => {
    return getters.service.getDuration(LOOKUP_TYPE.DurationTask).then((response) => {
      commit(lookupTypesStore.Set.LIST_OF_DURATION_TASKS, response);
      return Promise.resolve(response);
    });
  },
  [lookupTypesStore.Get.LIST_TASK_GROUP]: ({ getters, commit }, type: string) => {
    return getters.service.getTaskGroup(type).then((response: ApiResponse) => {
      commit(lookupTypesStore.Set.LIST_OF_TASK_GROUPS, response);
      return response;
    }).catch(error => {
      console.log(error);
      
    });
  },
  [lookupTypesStore.Get.LIST_CANDIDATES]: ({ getters, commit }, type: string) => {
    return getters.service.getListCandidate(type).then((response) => {
      commit(lookupTypesStore.Set.LIST_CANDIDATES, response);
      return Promise.resolve(response);
    });
  },
};

export default actions;